export default function LogoutConfirm({ v }) {
  if (!v.showLogoutConfirm) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" onClick={v.cancelLogout} style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "99", "padding": "20px" }}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(400px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "16px" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "11px" }}>
            <img alt="" src={v.myAvatarUrl} style={{ "width": "44px", "height": "44px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
            <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.4" }}>
              Weet je zeker dat je wilt uitloggen?
            </div>
          </div>
          <div style={{ "fontSize": "14px", "fontWeight": "600", "color": "var(--tekst-2)", "lineHeight": "1.4" }}>
            Je tekeningen blijven bewaard. Je kunt jezelf later weer uit de lijst kiezen.
          </div>
          <div style={{ "display": "flex", "gap": "8px", "justifyContent": "flex-end" }}>
            <button onClick={v.cancelLogout} className="gp-btn">
              Nee, blijf
            </button>
            <button onClick={v.logout} className="gp-btn pink">
              Ja, uitloggen
            </button>
          </div>
        </div>
      </div>
      {' '}
    </>
  );
}
